<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-btn color="primary" fab small dark @click="onAddNewClicked">
              <v-icon>add</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-layout row wrap>
              <v-flex sm6></v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="searchTable"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="desserts"
            :pagination.sync="pagination"
            :total-items="totalDesserts"
            :loading="loading"
            class="elevation-1"
            :rows-per-page-items="$CONFIG.tablePG"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.mobile }}</td>
                <td>{{ props.item.email }}</td>
                <td>
                  <v-menu offset-y transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn flat icon small color="primary" v-on="on">
                        <v-icon dark>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in rowActionItems"
                        :key="index"
                        @click="onRowActionItemClicked(item.value, props.item)"
                      >
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <v-btn fab bottom right color="pink" dark fixed @click.stop="productsAddModal=true;">
      <v-icon>add</v-icon>
    </v-btn>-->

    <v-dialog v-model="isAddFormModal" scrollable persistent max-width="1000px">
      <AddForm @cancelled="isAddFormModal = false" @added="getDataFromApi" />
    </v-dialog>
    <v-dialog v-model="isEditFormModal" scrollable persistent max-width="1000px">
      <EditForm @cancelled="isEditFormModal = false" :edit-item="editItem" />
    </v-dialog>
    <v-dialog v-model="isDetailsModal" scrollable persistent max-width="1000px">
      <DetailsView @cancelled="isDetailsModal = false" :item="editItem" />
    </v-dialog>


  </div>
</template>



<script>
import Nl2br from "vue-nl2br";
import AddForm from "./AgentAdd.vue";
import EditForm from "./AgentEdit.vue";
import DetailsView from "./AgentDetails.vue";

export default {
  components: {
    Nl2br,
    AddForm,
    EditForm,
    DetailsView
  },
  data: () => ({
    actionButtonClicked: false,

    headers: [
      { text: "Full Name", value: "name" },,
      { text: "Mobile", value: "mobile" },
      { text: "Email", value: "email" },
      { text: "Actions", value: "name", sortable: false },
    ],

    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},
    getApiaParams: {
      fields: "id,name,father_name,mother_name,present_district,present_upazila,present_union,present_village,permanent_district,permanent_upazila,permanent_union,permanent_village,dob,age,nid_number,nationality,gender,religion,mobile,emergency_contact,emergency_relation,company_name,company_staff_contact,email,notes",
      search_fields: "id,name,father_name,mother_name,present_district,present_upazila,present_union,present_village,permanent_district,permanent_upazila,permanent_union,permanent_village,dob,age,nid_number,nationality,gender,religion,mobile,emergency_contact,emergency_relation,company_name,company_staff_contact,email,notes",
    },
    searchTable: "",

    rowActionItems: [
      { title: "View Details", value: "details" },
      { title: "Edit", value: "edit" },
      { title: "Delete", value: "delete" },
    ],

    isAddFormModal: false,
    isEditFormModal: false,
    isDetailsModal: false,
    editItem: {},

    isPatientPrescriptionsModal: false,
    selectedPatient: {},
    patientPrescriptions: [],
    patientPrescription: {},
    patientPrescriptionDetails: {},
    isPreviewPrescripiton: false,
  }),

  computed: {},

  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    searchTable: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {},

  methods: {
    getDataFromApi() {
      this.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      if (sortBy == null) {
        delete this.getApiaParams.sort;
      } else {
        this.getApiaParams.sort = descending ? "-" + sortBy : "+" + sortBy;
      }
      this.getApiaParams.limit = rowsPerPage;
      this.getApiaParams.offset = (page - 1) * rowsPerPage;
      this.getApiaParams.search = this.searchTable;

      this.get("/agents", this.getApiaParams).then((response) => {
        this.desserts = response.data.data.items;
        this.totalDesserts = response.data.data.total_items;
        this.loading = false;
      });
    },
    onAddNewClicked() {
      this.isAddFormModal = true;
    },
    onEditClicked(item) {
      this.editItem = item;
      this.isEditFormModal = true;
    },
    onDetailsClicked(item) {
      this.editItem = item;
      this.isDetailsModal = true;
    },
    async onPrescriptionSelected(prescription) {
      this.patientPrescription = prescription;
      const res = await this.get(`/prescription/${prescription.id}`);
      this.patientPrescriptionDetails = res.data;
      this.isPreviewPrescripiton = true;
    },
    async onPrescriptionsClicked(item) {
      this.selectedPatient = item;
      this.patientPrescriptions = [];
      this.isPatientPrescriptionsModal = true;
      const res = await this.get("/prescription", {
        patient_id: item.id,
      });
      this.patientPrescriptions = res.data.data;
      console.log(res.data.data);
    },
    onAddPrescriptionClicked(item) {
      const { id } = item;
      this.$router.push({
        name: "prescription_add",
        query: { patient_id: id },
      });
    },
    onRowActionItemClicked(action, item) {
      switch (action) {
        case "details":
          this.onDetailsClicked(item);          
          break;
        case "edit":
          this.onEditClicked(item);
          break;
        case "delete":
          this.$confirm("Do you really want to DELETE agent ?").then(
            (isConfirmed) => {
              if (isConfirmed) {
                this.$http.delete("/agent/" + item.id).then((res) => {
                  if (res.data.success) {
                    this.desserts = this.desserts.filter(
                      (row) => row.id != item.id
                    );
                  }
                  this.snackbarShow(res.data);
                });
              }
            }
          );
          break;
      }
    },
  },

  beforeDestroy() {},
};
</script>